import React from "react";
import { TextField } from "components/configurationforms";
const TitleField = ({ typeName, helpText = "", value = "", onChange = () => {
} }) => {
  const titleField = {
    is_optional: false,
    attributes: [],
    human_name: "Title",
    description: helpText,
    is_encrypted: false,
    additional_info: {},
    default_value: "",
    position: 0,
    type: "text"
  };
  return /* @__PURE__ */ React.createElement(
    TextField,
    {
      key: `${typeName}-title`,
      typeName,
      title: "title",
      field: titleField,
      value,
      onChange,
      autoFocus: true
    }
  );
};
export default TitleField;
